/**
 * Copyright © Magento, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */
/* jshint browser:true jquery:true*/
define([
    'jquery',
    'mage/template',
    'popup',
    'matchSize',
    'pageLoader',
    'globalVars',
    'underscore',
    'mousewheel',
], ($, mageTemplate, popup, matchSize, pageLoader, { $body, $html }) => {
    /**
     * Check wether the incoming string is not empty or if doesn't consist of spaces.
     *
     * @param {String} value - Value to check.
     * @returns {Boolean}
     */

    $.widget('mage.quickSearch', {
        options: {
            minSearchLength: 2,
            searchSection: '#searchSection',
            searchMiniForm: '#searchMiniForm',
            searchInput: '#searchInput',
            close: '#searchClose',
            results: '#searchAutocompleteResult',
            itemsContent: '#searchAutocomplete',
            productsContent: '#searchAutocompleteBest',
            openSearchClass: '_search-open',
            itemsTmpl: '#searchItemTmpl',
            productsTmpl: '#searchProductsTmpl',
            autocompleteContent: '#searchAutocompleteContent',
            catalogUrl: '',
            searchUrlBase: '',
        },

        _buildEmptyTemplate() {
            return ''
                + '<% if (data.most_popular_search_term && data.most_popular_search_term.length) { %>'
                +     '<div class="search-autocomplete-empty">'
                +         '<div class="search-autocomplete-empty__title">'
                +             'По вашему запросу ничего не найдено. Попробуйте другой запрос или посмотрите '
                +             '<a href="' + this.options.catalogUrl + '" target="_blank">наш&nbsp;каталог</a>'
                +         '</div>'
                +         '<div class="search-autocomplete-popular">'
                +             '<div class="search-autocomplete-popular__title">Популярные запросы</div>'
                +             '<ul class="search-autocomplete-popular__list">'
                +                 '<% _.each(data.most_popular_search_term, function(term) { %>'
                +                     '<li class="search-autocomplete-popular__item">'
                +                         '<a href="' + this.options.searchUrlBase + '?q=<%- term %>" class="search-autocomplete-popular__link">'
                +                             '<%- term %>'
                +                         '</a>'
                +                     '</li>'
                +                 '<% }); %>'
                +             '</ul>'
                +         '</div>'
                +     '</div>'
                + '<% } %>';
        },

        _buildSearchProductsTemplate() {
            return ''
                + '<% if (data) { %>'
                +     '<div class="search-products js-product-bundle-wrap">'
                +         '<div class="search-product__list js-custom-scroll js-search-product-list">'
                +             '<% _.each(data.products, function(item) { %>'
                +                 '<div class="search-product-item">'
                +                     '<a href="<%- item.view_page_url %>" class="search-product-item__link">'
                +                         '<span class="search-product-item__img-wr">'
                +                             '<picture>'
                +                                 '<source media="(max-width: 767px)" srcset="<%- item.suggest_image_regular %> 1x, <%- item.suggest_image_retina %> 2x">'
                +                                 '<img src="<%- item.suggest_image_regular %>" srcset="<%- item.suggest_image_retina %> 2x" alt="search item image" class="search-product-item__img">'
                +                             '</picture>'
                +                         '</span>'
                +                         '<span class="search-product-item__details">'
                +                             '<span class="search-product-item__name">'
                +                                 '<%- item.product_category %>&nbsp;<%- item.series %>'
                +                             '</span>'
                +                             '<span class="search-product-item__description hide-on-mobile">'
                +                                 '<%= item.purpose %>'
                +                             '</span>'
                +                         '</span>'
                +                         '<span class="search-product-item__arrow"></span>'
                +                     '</a>'
                +                 '</div>'
                +             '<% }); %>'
                +         '</div>'
                +     '</div>'
                +     '<div class="search-autocomplete__all">'
                +         '<a href="<%- data.all_results_url %>" class="btn">Ко всем результатам</a>'
                +     '</div>'
                + '<% } %>';
        },

        _cache() {
            this.$searchSection = $(this.options.searchSection);
            this.$input = $(this.options.searchInput);
            this.searchAutocompleteContentId = '#searchAutocompleteContent';
            this.$searchProductList = $('.js-search-product-list');
        },

        _create() {
            this._cache();

            this.$searchSection.on('click', this.options.close, () => {
                this._toggleSearch(0);
            });

            $body.on('click', this.onTap.bind(this));

            $body.on('search:close', () => {
                this.close(false);
            });

            this._search();
            this._selectItem();

            this.options.emptyTmplString = this._buildEmptyTemplate();
            this.options.searchProductsTmplString = this._buildSearchProductsTemplate();
        },

        onTap(ev) {
            const $elem = $(ev.target);
            const visibilitySearch = $body.hasClass(
                this.options.openSearchClass
            );

            if (
                $elem.attr('id') === 'headerSearch' ||
                $elem.closest('#headerSearch').length
            ) {
                // PrventDefault needed in order for focus on input
                // to work properly on ios devices. Without it keyboard is not showing.
                ev.preventDefault();

                this._toggleSearch(!visibilitySearch);

                if (!visibilitySearch) {
                    this.$input.val('');
                }
            } else if (!this.$searchSection.has($elem).length) {
                this._toggleSearch(0);
            }
        },

        open(isVisible) {
            if (!matchSize().mobile) {
                isVisible && $(this.options.autocompleteContent).slideDown();
                $body.toggleClass(this.options.openSearchClass, isVisible);
                this.$input.attr('aria-expanded', true).focus();

                return;
            }

            setTimeout(() => {
                this.$input.attr('aria-expanded', true).focus();
            }, 300);

            $(this.options.searchSection).addClass('_open').show();
            $html.addClass('_menu-open _search-open');
        },

        close(isVisible) {
            if (!matchSize().mobile) {
                !isVisible && $(this.options.autocompleteContent).slideUp();
                $body.toggleClass(this.options.openSearchClass, isVisible);
                this.$input.attr('aria-expanded', true).blur();
                $(this.options.results).addClass('_hidden');

                return;
            }

            $(this.options.searchSection).removeClass('_open').hide();

            if ($html.hasClass('_search-open')) {
                $html.removeClass('_menu-open _search-open');
            }

            this.$input.val('');
            $(this.options.productsContent).empty();
            $(this.options.itemsContent).empty();

            setTimeout(() => {
                this.$input.attr('aria-expanded', true).focus();
            }, 300);
        },

        _toggleSearch(visible) {
            visible
                ? this.open(Boolean(visible))
                : this.close(Boolean(visible));
        },

        _toggleLoader(loading) {
            $(this.options.searchMiniForm).toggleClass(
                '_loading',
                Boolean(loading)
            );
        },

        _showEmpty(data) {
            $(this.options.productsContent).empty();
            $(this.options.itemsContent)
                .empty()
                .html(
                    $(
                        mageTemplate(this.options.emptyTmplString, {
                            data,
                        })
                    )
                );
        },

        _autocomplete() {
            if (this.options.loading) {
                return;
            }

            const data = {};

            data[this.$input.data('apiName')] = this.$input.val();

            $.ajax({
                url: this.options.url,
                dataType: 'json',
                data,

                beforeSend: () => {
                    this._toggleLoader(1);
                    $(this.options.results).addClass('_hidden');
                    pageLoader.showLoading();
                },

                success: data => {
                    if (data.total_count) {
                        this._addProducts(data);

                        if (matchSize().mobile) {
                            require(['mCustomScrollbar'], () => {
                                $('.js-custom-scroll').mCustomScrollbar({
                                    mouseWheel: {
                                        preventDefault: true,
                                    },
                                });
                            });
                        }
                    } else {
                        this._showEmpty(data);
                    }

                    setTimeout(() => {
                        $(this.options.results).removeClass('_hidden');
                    }, 300);
                },

                complete: () => {
                    this._toggleLoader(0);
                    pageLoader.hideLoading();
                    $(this.options.autocompleteContent).show();
                },
            });
        },

        _search() {
            let timerId = null;

            this.$input.on('input', () => {
                clearTimeout(timerId);

                timerId = setTimeout(() => {
                    if (
                        this.$input.val().length >= this.options.minSearchLength
                    ) {
                        this._autocomplete(this.$input.val());
                    }
                }, 500);
            });
        },

        _addProducts(data) {
            const products = this.combineAttributes(data.products);

            $(this.options.itemsContent).empty();

            $(this.options.productsContent).html(
                $(
                    mageTemplate(this.options.searchProductsTmplString, {
                        data: {
                            products,
                            all_results_url: data.all_results_url,
                        },
                    })
                )
            );
        },

        _selectItem() {
            $(this.options.itemsContent).on('click', 'li', event =>
                this.$input
                    .val($(event.currentTarget).data('lbl'))
                    .closest('form')
                    .trigger('submit')
            );
        },

        _fillQuery() {
            const $items = $(this.options.itemsContent).find(
                '.js-autocomplete-title'
            );
            const query = this.$input.val();

            $items.each((i, el) => {
                const replacedStr = `<span class="search-autocomplete__fill">${query}</span>`;
                const finalValue = $(el)
                    .data('lbl')
                    .toLowerCase()
                    .replace(query.toLowerCase(), replacedStr);

                $(el).html(finalValue);
            });
        },

        combineAttributes(products) {
            return products.map(product => {
                const extObj = Object.entries(
                    product.extension_attributes
                ).reduce(
                    (res, [newPropName, newValue]) => ({
                        ...res,
                        [newPropName]: newValue,
                    }),
                    {}
                );
                const customObj = product.custom_attributes.reduce(
                    (res, el) => ({ ...res, [el.attribute_code]: el.value }),
                    {}
                );
                const imgObj =
                    product.extension_attributes.extended_images &&
                    product.extension_attributes.extended_images.reduce(
                        (res, el) => ({ ...res, [el.type]: el.url }),
                        {}
                    );

                return {
                    ...product,
                    ...extObj,
                    ...customObj,
                    ...imgObj,
                };
            });
        },
    });

    return function (config, element) {
        $(element).quickSearch(config);
    };
});
